import styled from 'styled-components';
import {BGImageCenter, ellipsis} from '../../../../../../../globalVariables/GlobalVariables';
import {pencil} from '../../../../../../../assets/symbols/symbols/Symbols.css';
import {dFlexBetween} from '../../../../../../../globalVariables/GlobalFlex';

export const container = styled.div<{ rowHeight?: number }>`
    width: 100%;
    height: ${({rowHeight}) => (rowHeight ? `${rowHeight}px` : '50px')};
    transition: height 0.3s;
    overflow: hidden;
`;

export const row = styled.div`
    ${dFlexBetween}
    width: 100%;
    padding-inline: 15px;
    height: 45px;
    cursor: pointer;
`;

export const item = styled.div`
    width: 100px;
    overflow: hidden;
    ${ellipsis}
`;

export const boldItem = styled(item)`
    font-weight: 700;
    text-align: center;

`;
export const edit = styled(item)`
    text-align: end;
    opacity: 0.5;
    &::before{
        content: '';
        display: block;
        width: 15px;
        height: 15px;
        position: absolute;
        ${BGImageCenter(pencil,'10px')};
    }
`;

export const toggle = styled.div`
    width: 80px;
`;
